/* eslint-disable no-console */
import { ErrorBoundary } from '@sentry/react';
import LoadingScreen from 'components/LoadingScreen';
import PageLayout from 'components/PageLayout';
import ActiveFiltersBar from 'components/SearchAndFilters/SelectedFiltersBar';
import { useAtomValue, useSetAtom } from 'jotai';
import React, { Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import { Row, Col, CardTitle } from 'reactstrap';

import BulkActions from './BulkActions';
import Filters from './Filters';
import { useFilterConfig } from './Filters.config';
import FindingsDataGrid from './FindingsDataGrid';
import {
  filterValuesAtom,
  findingsDataAtom,
  useOnFilterChangeResetAtoms,
} from './state';

const SelectedFilters: React.FC<{ filtersConfig }> = ({ filtersConfig }) => {
  const setFilterValues = useSetAtom(filterValuesAtom);
  const resetOnFilterChangeAtoms = useOnFilterChangeResetAtoms();

  return (
    <Suspense fallback={<></>}>
      <ActiveFiltersBar
        filtersConfig={filtersConfig}
        onFiltersReset={() => {
          setFilterValues({ ...filtersConfig.getActiveFilterValues() });
          resetOnFilterChangeAtoms();
        }}
      />
    </Suspense>
  );
};

const ListingCount: React.FC = () => {
  const listingData = useAtomValue(findingsDataAtom);
  return <>{listingData?.loading ? '...' : listingData.count}</>;
};

function VulnListing() {
  const filtersConfig = useFilterConfig();

  return (
    <PageLayout
      id="findings_listing"
      heading={
        <Row>
          <Col md="auto" sm="12">
            <CardTitle>
              <h4>
                Vulnerabilities
                <label id="counts" className="label btn">
                  <Suspense fallback={<>...</>}>
                    <ListingCount />
                  </Suspense>
                </label>
              </h4>
            </CardTitle>
          </Col>
        </Row>
      }
      subheading="Identify and manage your vulnerabilities."
      filteringOptions={<Filters filtersConfig={filtersConfig} />}
    >
      <Suspense fallback={<LoadingScreen />}>
        <div className="container-fluid p-0">
          <div className="row mb-1">
            {/* Expanding Column */}
            <div className="col">
              <SelectedFilters filtersConfig={filtersConfig} />
            </div>

            {/* Fixed Column with Right-Aligned Content */}
            <div className="col-auto text-right align-baseline">
              <Suspense fallback={<>...</>}>
                <BulkActions />
              </Suspense>
            </div>
          </div>
          {/* <MockDataGrid /> */}
          <Suspense fallback={<LoadingScreen />}>
            <FindingsDataGrid />
          </Suspense>
        </div>
      </Suspense>
    </PageLayout>
  );
}

const Findings: React.FC = () => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <div className="content">
        <ErrorBoundary>
          <VulnListing />
        </ErrorBoundary>
      </div>
      <ToastContainer />
    </Suspense>
  );
};

export default Findings;
